module.exports = __webpack_public_path__ + "img/reset.92731104.svg";